import React, { Component } from 'react';

class HoursItem extends Component {
  render() {
    const { index, days, time } = this.props;
    // console.dir(days);

    return (
      <div className="hour-block" key={index}>
        <div className="days">{days}</div>
        <div className="time">{time}</div>
      </div>
    );
  }
}

export default HoursItem;
